import FournituresManager from "@features/achats/components/fournitures/FournituresManager";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Package } from "lucide-react";

export const Route = createFileRoute("/_app/achats/fournitures/")({
  staticData: {
    title: "Fournitures",
    icon: Package,
    tab_icon: Package,
    permission: PERMISSIONS.ACHATS.FOURNITURES.VIEW,
    module: "achats",
    order: 20,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: FournituresManager,
});
